
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { useHistory } from 'react-router-dom';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ChangePasswordForm from '../../common/client/components/ChangePasswordForm';
import Text from '../../common/client/components/Text';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';

import useNavigationItems  from '../../hooks/useNavigationItems';

const classNames = mergeStyleSets({
    ChangePasswordPage: {
    },
    panel: {
        backgroundColor: '#ffffff',
        marginTop: 64,
        marginBottom: 64,
        padding: 8,
        border: '1px solid #999999',
        width: 430
    },
});

const ChangePasswordPage = () => {

    const navigationItems = useNavigationItems();

    const history = useHistory();

    const handleCancelClick = () => {
        history.push('/');
    }

    return (
        <AppPageStyle
            navigationItems={navigationItems}
        >
            <Stack className={classNames.ChangePasswordPage}>
                <Stack.Item className={classNames.panel} align="center">
                    <Text xxLarge>Změna hesla</Text>
                    <ChangePasswordForm
                        onCancelClick={handleCancelClick}
                    />
                </Stack.Item>
            </Stack>
        </AppPageStyle>
    );
}

export default ChangePasswordPage;
